<div class="hidden xl:block lg:block">
  <div class="flex flex-row h-10rem mb-1">
    <div class="flex flex-column ml-0 mr-1 w-16rem">
      <div class="flex content-start">
        <img ngSrc="/images/DZBANK_Logo_oC_pos_RGB.svg" priority alt="DZ BANK Logo" height="80" width="248"
             class="mr-2"/>
      </div>
      <div class="flex">
        <h2 class="text-2xl font-bold mt-0 mb-0 text-color-secondary" [style]="{'padding-left': '34px'}">
          {{ headerTitle() }}
        </h2>
      </div>
    </div>
    <div class="flex-1" [style]="{'margin-top': '3rem', 'margin-left': '4rem'}">
      @if(showCustomerInclude()) {
        <app-customer-include></app-customer-include>
      }
    </div>
    <div class="flex-shrink-0 flex flex-row mt-2 align-items-center column-gap-2 ml-4 mr-4">
      <app-task-log></app-task-log>
      @if (!isCorporateMode()) {
        <app-helptext></app-helptext>
      }
      <!-- <app-print-button></app-print-button> -->
    </div>
    <div class="flex-shrink-0 flex flex-row mt-2 column-gap-2 mr-4">
      <div class="flex flex-column">
        <div class="flex-shrink-0" [style]="{'padding-top': '2.6rem'}">
          <app-user></app-user>
        </div>
        <div [style]="{'padding-top': '1.3rem'}">Datum {{ currentDate | date: 'mediumDate': 'de' }}</div>
      </div>
    </div>
  </div>
</div>

<div class="flex xl:hidden lg:hidden">
  <p-menubar class="flex-1">
    <ng-template pTemplate="start">
      <div class="flex flex-row align-items-center">
        <p-menu #menu [model]="items()" [popup]="true" class="flex-grow-1 pt-0 pl-2 overflow-x-hidden overflow-y-auto">
          <ng-template pTemplate="item" let-item>
            <a class="navbar-item p-menuitem-link flex text-color no-underline"
               [class.navbar-item-active]="item.active"
               [routerLink]="item.routerLink">
              <div class="flex align-items-center gap-3">
                <span class="navbar-icon flex-shrink-0 text-xl" [class]="item.icon"></span>
                <span class="text-md">{{ item.label }}</span>
              </div>
            </a>
          </ng-template>
        </p-menu>
        <p-button (click)="menu.toggle($event)" severity="secondary" [text]="true" icon="pi pi-bars"></p-button>
        <img ngSrc="/images/DZBANK_Logo_oC_pos_RGB.svg" height="60" width="186" priority
             alt="DZ BANK Logo"/>
      </div>
    </ng-template>
    <ng-template pTemplate="end">
      <app-user></app-user>
    </ng-template>
  </p-menubar>
</div>
